import React, { useState,useEffect } from "react";
import { Link,useLocation  } from "react-router-dom";


const TutorSidebar = () => {
    const tutor = JSON.parse(localStorage.getItem("tutor"));
    var tarr=tutor.name.split(" ");
   // console.log(tarr);
    var short_name=tarr[0].substring(0,1)+tarr[1].substring(0,1);
   return (
    <>
    <nav id="sidebar">

<div className="sidebar-header" align="center">

    <div align="center">

    <img src="/assets/images/lms-logo.png" style={{ maxHeight: `${60}px`}} />

    </div>    
    <h3>{tutor?.name}</h3>

    <strong>{short_name}</strong>

</div>

<ul className="list-unstyled components">

   <li>

        <Link to="/manager/dashboard">

            <i className="fa  fa-dashboard"></i>

            DASHBOARD

        </Link>

    </li>

    <li>

        <Link to="/manager/course-categories">

            <i className="fa fa-folder-open"></i>

            COURSE CATEGORIES

        </Link>

    </li>
    <li>

<Link to="/manager/courses">

    <i className="fa fa-list"></i>

    COURSES

</Link>

</li>

   
   
    
    
   {/* 

    


 <li ><a href="#practiceSubmenu" data-bs-toggle="collapse" aria-expanded="false"><i className="fa fa-retweet" aria-hidden="true"></i>PRACTICE QUESTIONS </a>

<ul className="collapse  list-unstyled" id="practiceSubmenu">

    <li >

 <a href="#speakingSubmenu" data-toggle="collapse" aria-expanded="false">

            <i className="glyphicon glyphicon glyphicon-volume-up"></i>

            SPEAKING

        </a>

        <ul className="collapse   list-unstyled" id="speakingSubmenu">

         
            <li><a href="https://www.endeavourstudy.com.au/speaking/read-aloud">READ ALOUD</a></li>

            
            <li><a href="https://www.endeavourstudy.com.au/speaking/repeat-sentence">REPEAT SENTENCE</a></li>

            
            <li><a href="https://www.endeavourstudy.com.au/speaking/describe-image">DESCRIBE IMAGE</a></li>

            
            <li><a href="https://www.endeavourstudy.com.au/speaking/retell-lecture">RETELL LECTURE</a></li>

            
            <li><a href="https://www.endeavourstudy.com.au/speaking/answer-short-question">ANSWER SHORT QUESTION</a></li>

            
        </ul>

    </li>
  */}
    
    
</ul>


</nav>

    </>
    

   );

}
export default TutorSidebar;